import type { ListParams } from '../type';
import baseKey from './_baseKey';

const attendanceDomainKey = () => baseKey.domainKey('attendance');

const attendanceKey = {
  /**
   * @returns 도메인 기본 쿼리키 (getter)
   * @example ['attendance']
   */
  domain() {
    return attendanceDomainKey();
  },
  /**
   * @param listParams 리스트 파라미터
   * @returns 페이지네이션 방식 리스트 요청 쿼리키
   * @example ['attendance', 'list', 'page', {...listParams}]
   */
  listByPage(listParams?: ListParams) {
    const coreKey = baseKey.listKey(attendanceDomainKey(), 'page');
    return listParams ? [...coreKey, listParams] : coreKey;
  },
};

export default Object.freeze(attendanceKey);
